import { RootStore } from "../index";
import { makeAutoObservable } from "mobx";
import axios from "axios";
import ContentModel from "../../model/ContentModel";

export class BannerStore {
  rowsBannerImage = [];

  private rootStore: RootStore | undefined;

  constructor(rootStore?: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  init() {
    ContentModel.getBannersB2B((res: any) => {
      this.rowsBannerImage = res.data.data;
    }, this.setError);
  }

  setError = (error: any) => {
    console.log(error);
    // this.error = error.response.data.message;
  };
}
